import Image from '@/components/Image/Image';
import {formatBadgeImageUrl} from '@/utils/journeysUtils';

type BadgeImageProps = {
    imageUrl?: string;
    alt?: string;
    size?: number;
    /** Resolution requested from AEM via `?width=N&height=N`. Defaults to 256. */
    fetchSize?: number;
    className?: string;
    style?: React.CSSProperties;
};

const BadgeImage = ({imageUrl, alt, size = 88, fetchSize = 256, className, style}: BadgeImageProps) => {
    const src = formatBadgeImageUrl(imageUrl, fetchSize, fetchSize);
    if (!src) return null;

    return (
        <Image
            src={src}
            alt={alt ?? ''}
            aria-hidden={!alt ? true : undefined}
            width={size}
            height={size}
            className={`object-contain${className ? ` ${className}` : ''}`}
            style={style}
        />
    );
};

export default BadgeImage;
